export default {"src":"/_next/static/media/tick.631e8e25.svg","height":9,"width":12,"blurWidth":0,"blurHeight":0};